import { render, staticRenderFns } from "./addScheme.vue?vue&type=template&id=16b6a7b9&scoped=true&"
import script from "./addScheme.vue?vue&type=script&lang=js&"
export * from "./addScheme.vue?vue&type=script&lang=js&"
import style0 from "./addScheme.vue?vue&type=style&index=0&id=16b6a7b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b6a7b9",
  null
  
)

export default component.exports